import React, { useEffect, useState } from "react";
import { Stack, Button, Fade, Box, IconButton, Modal } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { checkUserLoggedIn } from "../shared/commonfunctions";
import styles from "../pages/Styles/Congratulation.module.scss";
import { stageDetailsAPICall } from "../shared/APICalls";
import PDFViewerIframe from "../Components/PDFIframe/PDFWithIframe";
import CloseIcon from "@mui/icons-material/Close";
import DoneImage from "../Components/assets/Images/congratsdoneimage.svg";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80vW",
  height: "90vH",
  bgcolor: "background.paper",
  borderRadius: "20px",
  boxShadow: 24,
  padding: "0px 0px 0px 5px",
};

export default function CongratulationsPage() {
  const navigate = useNavigate();

  const [showModal, setshowModal] = useState(false);
  const [pdfUrl, setPdfUrl] = useState<any>("");
  const [open, setOpen] = React.useState(true);
  const [clientCode, setClientCode] = useState("");
  const [zipFileurl, setZipfileurl] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
    checkUserLoggedIn(navigate);

    let objNew: any = {
      stage: "congratulations",
    };

    stageDetailsAPICall(objNew)
      .then((response: any) => {
        const responseData = response?.data;
        // console.log("responseData", responseData.data);

        if (responseData?.data?.data?.application_no) {
          setClientCode(responseData?.data?.data?.application_no);
        }

        if (responseData?.data?.data?.application_url) {
          setPdfUrl(responseData?.data?.data?.application_url);
        }
        if (responseData?.data?.data?.documents_zip_url) {
          setZipfileurl(responseData?.data?.data?.documents_zip_url);
        }
      })
      .catch((error: any) => {});
  }, []);

  const handlePreviewClick = () => {
    setshowModal(true);
  };

  const handlePreviewClose = () => {
    setshowModal(false);
  };

  return (
    <div className={styles.mainWrapperTop}>
      <div className={styles.wrapper}>
        <div className={styles.step}>
          <img src={DoneImage} />
        </div>
        <div className={styles.leftContainer}>
          <div className={styles.headerSection}>
            <p className={styles.signup}>Congrats!</p>
            <p className={styles.signup}>
              Application Process is Submitted for Approval!
            </p>
            <div className={styles.textdiv}>
              <p className={styles.instructiontext}>
                Your application
                <span style={{ fontWeight: 700, margin: "0px 5px" }}>
                  #{clientCode}
                </span>{" "}
                is under review and may take up to 24 hours. You will receive an
                email with your credentials once processed.
              </p>
            </div>
            <div className={styles.buttonsSection}>
              <Button
                type="submit"
                variant="contained"
                sx={{
                  width: "200px",
                  height: "50px",
                }}
                className={styles.previewButton}
                id="aadharOpenLinkButton"
                onClick={handlePreviewClick}
              >
                View Application
              </Button>
              <a
                href={zipFileurl}
                style={{ color: "inherit", textDecoration: "none" }}
              >
                <Button
                  type="submit"
                  variant="outlined"
                  sx={{
                    width: "200px",
                    height: "50px",
                    color: "#000",
                  }}
                  className={styles.previewButton}
                  id="aadharOpenLinkButton"
                >
                  Download Documents
                </Button>{" "}
              </a>
            </div>
          </div>
        </div>
      </div>

      {showModal && (
        <Stack>
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            closeAfterTransition
            slotProps={{
              backdrop: {
                timeout: 500,
              },
            }}
          >
            <Fade in={open}>
              <Box sx={style}>
                {/* <PdfModal
                // url={"https://arxiv.org/pdf/quant-ph/0410100.pdf"}
                url={documentURL}
              /> */}
                <Stack
                  alignItems={"flex-end"}
                  marginRight={"10px"}
                  marginTop={"5px"}
                >
                  <IconButton onClick={handlePreviewClose}>
                    <CloseIcon />
                  </IconButton>
                </Stack>
                <div className={styles.pdfMobilePreview}>
                  {/* <img
                    src={esignImage}
                    style={{
                      width: "95%",
                      height: "100%",
                      objectFit: "inherit",
                      filter: "brightness(80%)",
                      marginBottom: "20px",
                    }}
                  /> */}

                  <a
                    href={pdfUrl}
                    download="Esign-PDF-document"
                    target="_blank"
                    rel="noreferrer"
                    className={styles.previewdownlaodesign}
                  >
                    <Button
                      variant="contained"
                      sx={{
                        background: "#1976d2",
                        "&:hover": { background: "#1976d2" },
                      }}
                    >
                      View Esign Document
                    </Button>
                  </a>
                </div>
                <div className={styles.pdfDesktopPreview}>
                  <PDFViewerIframe urldata={pdfUrl} />
                </div>
              </Box>
            </Fade>
          </Modal>
        </Stack>
      )}
    </div>
  );
}
